import React from 'react'
// import {Link} from 'gatsby'
import styled from 'styled-components'
import { Container, Row, Col } from 'reactstrap'
import { graphql } from 'gatsby'
import Phone from 'react-ionicons/lib/IosPhonePortrait'
import Mail from 'react-ionicons/lib/MdMail'
import { FaInstagram, FaFacebook } from 'react-icons/fa'
import logo from '../img/logo-small.png'

import LuwebLogo from '../img/luweb-logo-white.svg'

const StyledFooter = styled.div`
  background-color: ${({ theme }) => theme.colors.main};
  color: white !important;
  h2,
  h3,
  a {
    color: #fff !important;
  }
  h2 {
    text-align: center;
    font-size: 48px;
  }
  h3 {
    font-size: 20px;
  }
  #copyright {
    font-size: 12px;
    margin-bottom: 0;
  }
  .location {
    padding: 10px 0;
    address {
      margin-bottom: 10px;
    }
  }
  #footerLogo {
    width: 50px;
    height: auto;
  }
`

const footer = () => (
  <StyledFooter>
    <div id="footer" className="mt-5 pt-5 pb-5">
      <Container>
        <Row>
          <Col md={4} className="order-2 order-md-1">
            <div className="location">
              <h3 className="m-0 mb-2">Isis Wilrijk</h3>
              <address>Prins-Boudewijnlaan 310 B2610 Wilrijk</address>
              <a href="tel:+3234493724">
                <Phone fontSize="20px" color="#fff" /> 03/449.37.24
              </a>
            </div>
          </Col>

          <Col md={4} className="order-1 order-md-2">
            <img
              src={logo}
              alt="small logo"
              id="footerLogo"
              className="rounded shadow mx-auto d-block"
            />
          </Col>
          <Col md={4} className="order-3 order-md-3 d-flex flex-column">
            <a href="mailto:info@schoonheidsinstituut-isis.be">
              <Mail fontSize="20px" className="mr-2" color="#fff" />
              info@schoonheidsinstituut-isis.be
            </a>
            <div className="mt-4">
              <a
                href="https://www.facebook.com/schoonheidsinstituutisis/"
                target="_blank"
                rel="noopener noreferrer"
                className="d-inline-block mr-4"
              >
                <FaFacebook size="30" />
              </a>
              <a
                href="https://www.instagram.com/schoonheidsinstituut_isis/"
                target="_blank"
                rel="noopener noreferrer"
                className="d-inline-block"
              >
                <FaInstagram size="30" />
              </a>
            </div>
            {/* <div id="luweb">
              Made by{' '}
              <a href="https://luweb.be" target="_blank" rel="noopener noreferrer">
                <img
                  style={{ width: '40px', position: 'relative', top: '2px', left: '2px' }}
                  src={LuwebLogo}
                  alt="logo Luweb"
                />
              </a>
            </div> */}
          </Col>
        </Row>
        <p id="copyright" className="text-center mt-4">
          &copy; {new Date().getFullYear()} <span>Isis</span> - Alle rechten voorbehouden.
        </p>
      </Container>
    </div>
  </StyledFooter>
)

export default footer
